import {SimpleListItem} from '@github-ui/simple-list-view/SimpleListItem'
import {SkeletonText} from '@primer/react/experimental'
import {clsx} from 'clsx'

import styles from './ListParts.module.css'

/**
 * Skeleton loader for list items - displays 3 skeleton items
 */
export function ListItemsSkeletonLoader() {
  return (
    <>
      <li className={styles.skeletonItem}>
        <SkeletonText lines={2} />
      </li>
      <li className={styles.skeletonItem}>
        <SkeletonText lines={2} />
      </li>
      <li className={styles.skeletonItem}>
        <SkeletonText lines={2} />
      </li>
    </>
  )
}

/**
 * Custom title component that allows entire list item row to be clickable
 * Supports `as` prop for rendering as different elements
 */
export function ListItemTitle({
  children,
  className,
  href,
  as = 'a',
  onClick,
}: {
  children: React.ReactNode
  className?: string
  href?: string
  as?: React.ElementType
  onClick?: (e: React.MouseEvent) => void
}) {
  const Component = as
  return (
    <Component href={href} className={clsx(styles.itemTitle, className)} onClick={onClick}>
      <SimpleListItem.Title className={styles.itemTitleInner}>{children}</SimpleListItem.Title>
    </Component>
  )
}
